import type { CategoryConfig } from '@if/mui'
import { Calculator, CircleDollarSign, FileText, Gavel, MoreHorizontal, TriangleAlert } from 'lucide-react'

export const TEMPLATE_CATEGORIES: Record<string, CategoryConfig> = {
  decision: { Icon: Gavel },
  documents: { Icon: FileText },
  income: { Icon: CircleDollarSign },
  worksheet: { Icon: Calculator },
  urgent: { Icon: TriangleAlert, color: 'error' },
  other: { Icon: MoreHorizontal },
}
